import URI from "urijs";
import { APP_PDC_URL, API_PDC_URL_V2,  DOCUMENTS_BFF_BASEURL } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const documentsWithSearchConstants = {
  GET_DOCUMENTS_WITH_SEARCH_ERROR: "GET_DOCUMENTS_WITH_SEARCH_ERROR",
  GET_DOCUMENTS_WITH_SEARCH_START: "GET_DOCUMENTS_WITH_SEARCH_START",
  GET_DOCUMENTS_WITH_SEARCH_SUCCESS: "GET_DOCUMENTS_WITH_SEARCH_SUCCESS",
  GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START: "GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START",
  GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS: "GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS",
  GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR: "GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR",
  GET_LINKED_DOCUMENTS_START: "GET_LINKED_DOCUMENTS_START",
  GET_LINKED_DOCUMENTS_SUCCESS: "GET_LINKED_DOCUMENTS_SUCCESS",
  GET_LINKED_DOCUMENTS_ERROR: "GET_LINKED_DOCUMENTS_ERROR",
  SAVE_LINKED_DOCUMENTS_ERROR: "SAVE_LINKED_DOCUMENTS_ERROR",
  SAVE_LINKED_DOCUMENTS_START: "SAVE_LINKED_DOCUMENTS_START",
  SAVE_LINKED_DOCUMENTS_SUCCESS: "SAVE_LINKED_DOCUMENTS_SUCCESS",
  CLEAR_DOCUMENTS_WITH_SEARCH: "CLEAR_DOCUMENTS_WITH_SEARCH",
  CLEAR_TOTAL_COUNT: "CLEAR_TOTAL_COUNT",
  CHANGE_TEXT_FILTER: "CHANGE_TEXT_FILTER",
  TOGGLE_FILTER: "TOGGLE_FILTER",
  READ_OR_NOT: "READ_OR_NOT",
  GET_DOCS_WIDGET_SUCCESS: "GET_DOCS_WIDGET_SUCCESS",
  GET_DOCS_WIDGET_ERROR: "GET_DOCS_WIDGET_ERROR",
  GET_WORKSPACEID_ERROR: "GET_WORKSPACEID_ERROR",
  GET_WORKSPACEID_SUCCESS: "GET_WORKSPACEID_SUCCESS"
};

export function updateReadCustomer(documentId) {
  return function(dispatch) {
    dispatch({
      type: documentsWithSearchConstants.READ_OR_NOT,
      payload: { documentID: documentId }
    });
  };
}
// https://stackoverflow.com/questions/35819806/rest-hateoas-and-reactjs

export function toggleFilter(filterIndex) {
  return function(dispatch) {
    dispatch({
      type: documentsWithSearchConstants.TOGGLE_FILTER,
      payload: { index: filterIndex }
    });
  };
}

export function getWorkspaceId() {
  return (dispatch, getState) => {
    const accountantId = getState().main.accountantUuidSelected;
    const itemId = getState().main?.companyUuidSelected;
    const auth = getState().auth;
    const urlLink = `${DOCUMENTS_BFF_BASEURL}/api/v1/documents/getAllowedWorkspaces?itemId=${itemId}&counterpart=${accountantId}`;

    return new Promise(function(resolve, reject){
      const request = {
        method: "GET",
        url: urlLink,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        validateStatus: () => true
      };
      callWithRetry(
        auth, request, dispatch, null, true, false
      ).then((result) => {
        dispatch({
          type: documentsWithSearchConstants.GET_WORKSPACEID_SUCCESS,
          payload: {
            response: result.data
          }
        });
        resolve(result.data);
      })
        .catch((error) => {
          const responseCode = error.response && error.response.status
            ? error.response.status
            : error.response && error.response.code
              ? error.response.code
              : error.response;
          dispatch({
            type: documentsWithSearchConstants.GET_WORKSPACEID_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: responseCode
            }
          });
          reject(error.response);
        });
    });
  };
}
export function getDocsWidget() {
  return (dispatch, getState) => {
    const accountantId = getState().main.accountantUuidSelected;
    const itemId = getState().main?.companyUuidSelected;
    const auth = getState().auth;
    const urlLink = `${DOCUMENTS_BFF_BASEURL}:/api/v1/documents/getDocsWidget?itemId=${itemId}&accountantId=${accountantId}`;

    return new Promise(function(resolve, reject){
      const request = {
        method: "GET",
        url: urlLink,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        validateStatus: () => true
      };
      console.log(
        "getDocsWidget",auth,request
      );
      callWithRetry(
        auth, request, dispatch, null, true, false
      ).then((result) => {
        dispatch({
          type: documentsWithSearchConstants.GET_DOCS_WIDGET_SUCCESS,
          payload: {
            response: result.data
          }
        });
        resolve(result.data);
      })
        .catch((error) => {
          const responseCode = error.response && error.response.status
            ? error.response.status
            : error.response && error.response.code
              ? error.response.code
              : error.response;
          dispatch({
            type: documentsWithSearchConstants.GET_DOCS_WIDGET_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: responseCode
            }
          });
          reject(error.response);
        });
    });
  };
}

export function getDocumentsWithSearch(
  link,
  txtSearch,
  isAppend = false,
  additionalProps = null,
  removeProps = [],
  reset = false
) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantIdSelected = main.accountantIdSelected;
    const clientIdSelected = main.clientIdSelected;

    let firstLink = APP_PDC_URL +
    "/v2/documents/?accountantId=" +
    accountantIdSelected +
    "&itemId=" +
    clientIdSelected +
    "&prefix=" +
    txtSearch;

    let urlLink = link ? link : firstLink;
    
    if (typeof additionalProps === "object") {
      for (let item in additionalProps) {
        if (item) {
        // rimozione parametri identici dalla stringa url
          let regex = new RegExp(`[&]${item}=[^&]+`, "");
          let newUrlLink = urlLink.replace(regex, "").replace(/^&/, "?"); // remove items
          urlLink = `${newUrlLink}&${item}=${additionalProps[item]}`; // add item one time
        }
      }
    }

    if (txtSearch) {
      let regex = new RegExp("[&]prefix=[^&]+", "");
      let regex2 = new RegExp("[&]prefix=", "");
      let newUrlLink = urlLink.replace(regex, "").replace(/^&/, "?").replace(regex2, ""); // remove prefix if present
      urlLink = newUrlLink + "&prefix=" + txtSearch;
    }

    if (typeof removeProps === "object") {
      removeProps.forEach(item => {
        if (item) {
          let regex = new RegExp(`[&]${item}=[^&]+`, "");
          urlLink = urlLink.replace(regex, "").replace(/^&/, "?"); // remove items
        }
      });
      if (removeProps.includes("prefix")) {
        urlLink = urlLink + "&prefix=";
      }
    }

    let uri = new URI(urlLink);

    let parameter = uri.search(true);
    if (
      typeof parameter.filterFromDate === "object" &&
    parameter.filterFromDate.length > 1
    ) {
      parameter.filterFromDate.shift();
    }
    if (
      typeof parameter.filterToDate === "object" &&
    parameter.filterToDate.length > 1
    ) {
      parameter.filterToDate.shift();
    }

    parameter = URI.buildQuery(parameter).toString();
    let basedURI = uri.search("").toString();
    urlLink = basedURI + "?" + parameter;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_START,
        payload: { isAppend: isAppend }
      });

      let request = {
        method: "GET",
        url: urlLink,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        validateStatus: () => true
      };
      console.log(
        "getDocsWidget",auth,request
      );

      callWithRetry(
        auth, request, dispatch, null, true, false
      )
        .then(result => {
          dispatch({
            type: documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS,
            payload: {
              response: result.data,
              firstLink: firstLink,
              txtSearch: txtSearch,
              currentLink: urlLink,
              isAppend: isAppend,
              reset: reset
            }
          });
          resolve(result.data);
        })
        .catch(error => {
          let responseCode = error.response && error.response.status
            ? error.response.status
            : error.response && error.response.code
              ? error.response.code
              : error.response;
          dispatch({
            type: documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: responseCode
            }
          });
          reject(error.response);
        });
    });
  };
}

export function getDocumentsWithSearchSimple(
  link,
  txtSearch,
  accountantSelected,
  accountantIdSelected,
  companySelected,
  clientIdSelected,
  isAppend = false,
  additionalProps = null
) {
  let firstLink = APP_PDC_URL +
    "/v2/documents?accountantId=" +
    accountantIdSelected +
    "&itemId=" +
    clientIdSelected +
    "&prefix=" +
    txtSearch;

  let urlLink = link ? link : firstLink;

  if (typeof additionalProps === "object") {
    for (let item in additionalProps) {
      if (item) {
        // rimozione parametri identici dalla stringa url
        let regex = new RegExp(`[&]${item}=[^&]+`, "");
        let newUrlLink = urlLink.replace(regex, "").replace(/^&/, "?");
        urlLink = `${newUrlLink}&${item}=${additionalProps[item]}`;
      }
    }
  }
  let uri = new URI(urlLink);

  let parameter = uri.search(true);
  if (
    typeof parameter.filterFromDate === "object" &&
    parameter.filterFromDate.length > 1
  ) {
    parameter.filterFromDate.shift();
  }
  if (
    typeof parameter.filterToDate === "object" &&
    parameter.filterToDate.length > 1
  ) {
    parameter.filterToDate.shift();
  }

  parameter = URI.buildQuery(parameter).toString();
  let basedURI = uri.search("").toString();
  urlLink = basedURI + "?" + parameter;

  return function(dispatch, getState) {

    const auth = getState().auth;    

    return new Promise(function(resolve, reject) {
      dispatch({
        type: documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_START,
        payload: { isAppend: isAppend }
      });

      let request = {
        method: "GET",
        url: urlLink,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          /**
           * questo fix per ovviare al problema della modifica (in quanto eliminato un tag o un intero documento)
           * di un doc con filtro selezionato con 1 solo item. Quando mi ritorna un array vuoto e sono
           * in situazione filtro attivo, rifaccio chiamata con il link di partenza senza filtri
           */

          if (
            result.data.results.length === 0 &&
            urlLink !== firstLink &&
            !additionalProps &&
            !txtSearch
          ) {
            // rifaccio la chiamata con il firstLink

            dispatch(getDocumentsWithSearchSimple(
              auth,
              null,
              txtSearch,
              accountantSelected,
              accountantIdSelected,
              companySelected,
              clientIdSelected,
              false,
              false
            ));
            resolve();
          } else {
            dispatch({
              type: documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_SUCCESS,
              payload: {
                response: result.data,
                firstLink: firstLink,
                txtSearch: txtSearch,
                currentLink: urlLink,
                isAppend: isAppend
              }
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SIMPLE_ERROR,
            payload: {
              message: "Si è verificato un errore",
              code: response.code ? response.code : 500
            }
          });
          reject();
        });
    });
  };
}

export function getLinkedDocuments(documentId) {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const accountantId = getState().main.accountantIdSelected;
    const itemId = getState().main.clientIdSelected;

    new Promise(function(resolve, reject) {
      let request = {
        method: "get",
        url: `${API_PDC_URL_V2}/documents/${documentId}/link?accountantId=${accountantId}&itemId=${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      dispatch({
        type: documentsWithSearchConstants.GET_LINKED_DOCUMENTS_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200) {
            dispatch({
              type: documentsWithSearchConstants.GET_LINKED_DOCUMENTS_SUCCESS,
              payload: {
                linkedDocumentsData: result.data
              }
            });
          } else {
            dispatch({
              type: documentsWithSearchConstants.GET_LINKED_DOCUMENTS_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch(response => {
          dispatch({
            type: documentsWithSearchConstants.GET_LINKED_DOCUMENTS_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function saveLinkedDocuments(documentId,
  linkedDocuments) {
  return (dispatch, getState) => {

    const auth = getState().auth;
    const accountantId = getState().main.accountantIdSelected;
    const itemId = getState().main.clientIdSelected;

    new Promise(function(resolve, reject) {
      let request = {
        method: "put",
        url: `${API_PDC_URL_V2}/documents/${documentId}/link?accountantId=${accountantId}&itemId=${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: linkedDocuments
      };

      dispatch({
        type: documentsWithSearchConstants.SAVE_LINKED_DOCUMENTS_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          if (result.status === 200) {
            dispatch({
              type: documentsWithSearchConstants.SAVE_LINKED_DOCUMENTS_SUCCESS
            });
            dispatch(getLinkedDocuments(documentId));
          } else {
            dispatch({
              type: documentsWithSearchConstants.SAVE_LINKED_DOCUMENTS_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch(response => {
          dispatch({
            type: documentsWithSearchConstants.SAVE_LINKED_DOCUMENTS_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}

export function clearTotalCount() {
  return function(dispatch) {
    dispatch({
      type: documentsWithSearchConstants.CLEAR_TOTAL_COUNT
    });
  };
}

export function changeTextFilter(value) {
  return function(dispatch) {
    dispatch({
      type: documentsWithSearchConstants.CHANGE_TEXT_FILTER,
      payload: { txtSearch: value }
    });
  };
}

export function clearDocumentsWithSearch() {
  return function(dispatch) {
    dispatch({
      type: documentsWithSearchConstants.CLEAR_DOCUMENTS_WITH_SEARCH
    });
  };
}
